import React from 'react';
import { Card } from './ui/card';
import { services } from '../data/mock';
import { FileCheck, Building2, TrendingUp, Users } from 'lucide-react';

const iconMap = {
  FileCheck,
  Building2,
  TrendingUp,
  Users,
};

const ServicesSection = () => {
  return (
    <section id="servicios" data-testid="services-section" className="py-24 sm:py-32 bg-[#0F0F0F]">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-24">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="inline-block text-[#D4A520] font-medium text-sm uppercase tracking-[0.2em] mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Nuestros Servicios
          </span>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-5 tracking-tight">
            ¿Por qué elegirnos?
          </h2>
          <div className="w-16 h-[1px] bg-[#D4A520] mx-auto mb-6" />
          <p className="text-white/50 text-base max-w-2xl mx-auto" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Te acompañamos en cada paso del proceso para encontrar tu hogar ideal
          </p>
        </div>

        {/* Services Bento Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                data-testid={`service-card-${service.id}`}
                className="group p-8 bg-[#1A1A1A] border border-[#D4A520]/10 rounded-none hover:border-[#D4A520]/40 transition-all duration-500 hover:-translate-y-2 hover:shadow-xl hover:shadow-[#D4A520]/5"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="w-14 h-14 border border-[#D4A520]/30 flex items-center justify-center mb-6 group-hover:bg-[#D4A520]/10 transition-all duration-300">
                  {IconComponent && <IconComponent className="w-7 h-7 text-[#D4A520]" />}
                </div>
                <h3 className="text-xl font-semibold text-white mb-3 group-hover:text-[#D4A520] transition-colors">
                  {service.title}
                </h3>
                <p className="text-white/40 leading-relaxed" style={{ fontFamily: 'Outfit, sans-serif' }}>
                  {service.description}
                </p>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
